<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-form ref="form" lazy-validation>
      <v-layout>
        <h1><span>{{title}}</span></h1>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mx-1" dark @click="save">Сохранить</v-btn>
        <v-btn color="primary" class="mx-1" dark @click="clear">Очистить</v-btn>
        <v-btn color="primary" class="ml-1 mr-0" dark @click="goBack">Вернуться</v-btn>
      </v-layout>

      <v-alert :value="alert" type="success">Организация сохранена</v-alert>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                tabindex="1"
                label="Название"
                v-model="editedItem.name"
                :error-messages="nameErrors"
                required
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
    <ErrorDialog :dialog="errorDialog"/>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import ObjectUtils from '@/utils/ObjectUtils'
import Dialog from '@/components/fragments/Dialog'
import {required} from 'vuelidate/lib/validators'
import OrganizationService from '@/services/OrganizationService'
import ErrorDialog from '@/components/fragments/ErrorDialog'

export default {
  props: {
    organization: Object,
    editing: false
  },
  components: {ErrorDialog, Dialog},
  data: () => ({
    alert: false,
    defaultItem: OrganizationService.getDefaultItem(),
    editedItem: {},
    errorDialog: {
      status: false,
      errors: [],
      title: 'Ошибка при сохранении'
    },
    organizationService: undefined
  }),
  computed: {
    title () {
      return this.editing ? 'Редактирование организации' : 'Добавление организации'
    },
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    },
    nameErrors () {
      const errors = []
      if (!this.$v.editedItem.name.$dirty) return errors
      !this.$v.editedItem.name.required && errors.push('Поле должно быть заполнено.')
      return errors
    }
  },
  methods: {
    save () {
      this.alert = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.organizationService.saveItem(this.editedItem, this.editing, (data) => {
          if (data.status) {
            this.alert = true
            if (!this.editing) this.clear()
          } else {
            this.errorDialog.errors = data.errors
            this.errorDialog.status = true
          }
        })
      }
    },
    goBack () {
      this.$router.back()
    },
    clear () {
      this.$v.$reset()
      this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
    }
  },
  created () {
    this.organizationService = new OrganizationService(this.$store)
    this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
  },
  watch: {
    organization (val) {
      this.editedItem = ObjectUtils.jsonCopy(val)
    },
    'errorDialog.status' (val) {
      if (!val) {
        this.errorDialog.errors = []
      }
    }
  },
  validations: {
    editedItem: {
      name: {required}
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/organization/EditForm.vue